import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { AxiosHeaders, AxiosRequestConfig } from 'axios';

import { DefaultListCodesRequestArgs } from './includes/defaults';
import { ListCodesSchema } from './includes/schema';
import { ListCodesData, ListCodesQueryPayload } from './includes/types';

interface CustomRequestHeaders extends AxiosHeaders {
  'x-api-endpoint': string;
}

/**
 * Query: ListCodes
 *
 * Retrieves a list of codes from the remote API via an authenticated GET request.
 * Validates the response data using a Zod schema.
 * Logs errors and rethrows them for upstream handling.
 */
export const ListCodes = async (
  payload: ListCodesQueryPayload = ['Code', 'ListCodes', DefaultListCodesRequestArgs]
): Promise<ListCodesData> => {
  try {
    const [theApiKey, theQueryKey, thePayload] = payload;

    const requestArgs: AxiosRequestConfig = {
      baseURL: config('API_URL'),
      headers: { 'x-api-endpoint': `/code-lists/categories/${thePayload?.categoryCode}` } as CustomRequestHeaders,
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    return ListCodesSchema.parse(remoteResponse.data);
  } catch (error) {
    logger.error('src/entities/Code/api/requests/queries/ListCodes/ListCodes.ts -> ListCodes()', false, error);
    throw error;
  }
};
